module.exports = __webpack_public_path__ + "static/media/jardinage1.0205f5bc.jpg";